import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {MembershipTypeCustomObjectTypeEntityModel} from "../membership-type-custom-object-type-entity.model";
import {CustomObjectTypeEditPageComponent} from "./custom-object-type-edit-page.component";
import {MembershipTypeCustomObjectEditPageComponent} from "../../custom-object/custom-object-edit-page/membership-type-custom-object-edit-page.component";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-membership-type-custom-object-type-edit-page",
    templateUrl: "./custom-object-type-edit-page.component.html",
    providers: [provideEntityModel(MembershipTypeCustomObjectTypeEntityModel)]
})
export class MembershipTypeCustomObjectTypeEditPageComponent extends CustomObjectTypeEditPageComponent {
    override CustomObjectEditPageComponent = MembershipTypeCustomObjectEditPageComponent;
    override fixedType: boolean = true;

    constructor(model: MembershipTypeCustomObjectTypeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(model, changeDetectorRef, responsiveService);
    }
}
